export enum LoadState {
  Error,
  Success,
  Loading,
  Idle,
}
